// extracted by mini-css-extract-plugin
export default {"mainContainer":"StudyFlashcards_mainContainer__pP5oT","flashcard":"StudyFlashcards_flashcard__VLHG3"};